export default __webpack_public_path__ + "static/media/hawaii.d9254f72.jpg";